import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { imageHandling } from '@shared/imageHandling';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-pdp-images-modal',
  templateUrl: './pdp-images-modal.component.html',
  styleUrls: ['./pdp-images-modal.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatDialogModule]
})
export class PdpImagesModalComponent implements OnInit {

  public url: string;
  public imageScale = 1;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { url: string }
  ) { }

  ngOnInit(): void {
    if (this.data.url) {
      this.url = imageHandling(this.data.url, 'full', '.webp');
    }
  }

  public scaleDown(): void {
    if (this.imageScale > 1) {
      this.imageScale = this.imageScale - 0.25;
    }
  }

  public scaleUp(): void {
    if (this.imageScale < 2) {
      this.imageScale = this.imageScale + 0.25;
    }

  }

}
